import { Button, Modal } from "@/ui";

export function ConfirmModal({ open, title, body, confirmLabel = "Confirm", danger, onConfirm, onClose, loading, disabled }: { open: boolean; title: string; body?: React.ReactNode; confirmLabel?: string; danger?: boolean; onConfirm: () => void; onClose: () => void; loading?: boolean; disabled?: boolean }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button variant={danger ? "danger" : "primary"} onClick={onConfirm} loading={loading} disabled={disabled} autoFocus={!disabled}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {body}
    </Modal>
  );
}
